@let route = route$ | async;
@if (!route?.isLogin) {
  <app-top-bar />
  @if (!route?.isSearch) {
    <side-bar />
  }
  @if (route?.isSearch) {
    <app-side-bar-search />
  }
}
<div id="eeh-navigation-page-wrapper">
  <div class="page-content-wrapper">
    <ng-content />
    <router-outlet />
  </div>
</div>

<div class="bottom-panel">
  <operation-feedback />
  <fw-snackbar-container />
</div>

<!-- Agent Chatbox Integration -->
@if (configService.isAssistantChatEnabled()) {
  <agent-chatbox />
}
